import { Dispatch, FC, SetStateAction } from 'react';
import { SelectedRoadmap } from './SettingsTabRoadmaps';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';

interface TargetGroup {
  id: string;
  name: string | null | undefined;
}

interface Props {
  selectedRoadmap: SelectedRoadmap;
  setSelectedRoadmaps: Dispatch<SetStateAction<SelectedRoadmap[]>>;
  targetGroup: TargetGroup;
  setExpandedKeys: Dispatch<SetStateAction<{ [key: string]: boolean }>>;
}

const PanelMenuCheckboxTemplate: FC<Props> = ({
  selectedRoadmap,
  setSelectedRoadmaps,
  targetGroup,
  setExpandedKeys,
}) => {
  const handleCheckboxChange = (siteId: string, targetGroup: { id: string; name: string }, checked: boolean) => {
    setExpandedKeys(prev => prev);
    setSelectedRoadmaps(prev =>
      prev.map(site => {
        if (site.siteId !== siteId) return site;
        const isAlreadySelected = site.targetGroup.some(g => g.id === targetGroup.id);
        const updatedGroups = checked
          ? isAlreadySelected
            ? site.targetGroup
            : [...site.targetGroup, targetGroup]
          : site.targetGroup.filter(g => g.id !== targetGroup.id);
        return { ...site, targetGroup: updatedGroups };
      }),
    );
  };

  return (
    <>
      <div className="flex p-2">
        <Checkbox
          value={targetGroup.id}
          checked={selectedRoadmap.targetGroup.some(tg => tg.id === targetGroup.id)}
          onChange={e => {
            e.stopPropagation();
            e.preventDefault();
            handleCheckboxChange(
              selectedRoadmap.siteId,
              targetGroup as { id: string; name: string },
              e.checked ?? false,
            );
          }}
        />
        <label htmlFor={targetGroup.id} className="ml-1" style={{ fontFamily: 'Poppins' }}>
          {targetGroup.name}
        </label>
      </div>
      <Divider className="m-0" />
    </>
  );
};

export default PanelMenuCheckboxTemplate;
